<template>
  <div class="highlights-date-container">
    <v-card class="fill-height">
      <div class="date-card-header">
        <h1 class="title mb-8">Data de validade</h1>
        <div class="expiration-date">
          <mf-date-range-picker
            icon
            outlined
            label="Período de validade"
            :min="minInitialDate"
            :initial-date.sync="highlight.initialDate"
            :final-date.sync="highlight.finalDate"
            :disabled="disableFields || isOfferSchedule"
            :error-messages="errorMessages"
            :edit-only-end-date="editOnlyEndDate"
          />
        </div>
        <mf-info-card v-if="isOfferSchedule" variant="info" description="Data de validade fixada na mesma validade da oferta selecionada." />
      </div>
    </v-card>
  </div>
</template>
<script>
import { DateTime } from 'luxon'

export default {
  name: 'ExpirationDateCard',
  components: {},
  props: {
    highlight: {
      type: Object,
      default: () => {},
    },
    startDateError: {
      type: String,
      default: '',
    },
    endDateError: {
      type: String,
      default: '',
    },
    isOfferSchedule: {
      type: Boolean,
      default: false,
    },
    disableFields: {
      type: Boolean,
      default: false,
    },
    editOnlyEndDate: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    initialDate: '',
    finalDate: '',
  }),
  computed: {
    errorMessages() {
      return this.startDateError.concat(this.endDateError)
    },
    minInitialDate() {
      return DateTime.now().toFormat('yyyy-MM-dd')
    },
  },
  mounted() {
    if (this.startDate) this.initialDate = this.startDate
    if (this.endDate) this.finalDate = this.endDate
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.highlights-date-container {
  width: 100%;
  height: 100% !important;
  .date-card-header {
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start !important;
    .expiration-date {
      width: 50%;
    }
  }
}
</style>
